<template>
  <div>
    <b-container fluid>
      <b-row>
        <!-- Listar lote -->
        <b-col cols="12" :lg="formCollapsed ? 12 : 8">
          <h2>{{ this.$gui.createdBatches }}</h2>

          <b-link class="d-block mb-3 d-lg-none" href="#cadastrar-novo">Cadastrar novo {{ $gui.batchLC }}</b-link>

          <!-- Filtros -->
          <b-row>
            <b-col cols="12" class="mb-3">
              <div class="w-auto d-inline-block mr-4">
                <p class="mb-2 font-weight-bold">Filtros:</p>
                <b-button class="mr-1 mb-1" v-b-modal.filter-batch-name>Nome</b-button>
                <b-button class="mr-1 mb-1" v-b-modal.filter-batch-stock>Estoque</b-button>
                <b-button class="mr-1 mb-1" v-b-modal.filter-batch-price>Preço</b-button>
                <b-button class="mr-1 mb-1" v-b-modal.filter-batch-category>Categoria</b-button>
                <b-button class="mr-1 mb-1" v-b-modal.filter-batch-situation>Situação</b-button>
              </div>
              <div class="w-auto d-inline-block">
                <p class="mb-2 font-weight-bold d-none d-md-block">&nbsp;</p>
                <b-button class="mr-1 mb-1" variant="info" @click="resetFilterBatches">Limpar filtros</b-button>
                <b-button variant="info" class="mr-2 mb-1" @click="getEvent">Recarregar {{ $gui.batchesLC }}</b-button>
                <b-button variant="success" class="mr-2 mb-1" @click="showSeriesModal = true">Criar em série</b-button>
                <b-button variant="warning" class="mr-2 mb-1" :disabled="effectiveSelection.length === 0" @click="showPriceModal = true">Alterar preço ({{ effectiveSelection.length }})</b-button>
                <b-button v-if="formCollapsed" class="mt-2 mb-1" variant="primary" @click="toggleForm(false)" v-b-tooltip.hover title="Expandir formulário">
                  <icon name="chevron-right" scale="0.9"></icon> Cadastrar {{ $gui.batchLC }}
                </b-button>
              </div>
            </b-col>
          </b-row>

          <!-- Filtros aplicados -->
          <b-row v-if="appliedFilters.length > 0">
            <b-col cols="12" class="mb-3">
              <b-card-group>
                <b-card no-body>
                  <b-list-group flush>
                    <b-list-group-item v-for="(item, index) in appliedFilters" :key="index">
                      <strong>{{ item.filter }}:</strong> {{ item.values }}
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-card-group>
            </b-col>
          </b-row>

          <!-- Resumo por situação -->
          <b-row v-if="event.batches && event.batches.length > 0">
            <b-col cols="12" class="mb-2">
              <span v-for="(item, index) in situationSummary" :key="item.key">
                <span v-if="index > 0"> · </span>
                <b-link v-if="item.count > 0" :class="{'font-weight-bold': filter.situation === item.key}" @click="toggleSituation(item.key)">{{ item.text }}</b-link>
                <span v-else class="text-muted">{{ item.text }}</span>
              </span>
            </b-col>
          </b-row>

          <!-- Tabela de lotes -->
          <b-row>
            <b-col>
              <b-table striped hover show-empty
                class="my-4"
                primary-key="id"
                empty-text="Nenhum lote encontrado"
                responsive
                :fields="this.$gui.isEvento ? fieldsEvento : fieldsFicha"
                :items="event.batches"
                :filter="filter"
                :filter-function="filterBatches"
                :empty-filtered-text="'Não foram encontrados ' + $gui.batchesLC + ' com esses filtros'"
                @filtered="onFiltered">

                <template v-slot:head(select)>
                  <b-form-checkbox :checked="allShownSelected" @change="toggleAllShown"></b-form-checkbox>
                </template>

                <template v-slot:cell(select)="data">
                  <span v-b-tooltip.hover :title="lockMessage(data.item.price_lock)">
                    <b-form-checkbox v-model="selectedIds" :value="data.item.id" :disabled="!!data.item.price_lock"></b-form-checkbox>
                  </span>
                </template>

                <template v-slot:cell(stock_fmted)="data">
                  <span v-if="data.item.stock === null" class="text-primary">Ilimitado</span>
                  <span v-else-if="data.item.stock === 0" class="text-danger">Sem estoque</span>
                  <span v-else-if="data.item.stock === 1">{{ data.item.stock }} unidade</span>
                  <span v-else>{{ data.item.stock | number }} unidades</span>
                </template>

                <template v-slot:cell(situation_fmted)="data">
                  <b-badge v-if="situationLabels[data.item.situation]" :variant="situationLabels[data.item.situation].variant">{{ situationLabels[data.item.situation].label }}</b-badge>
                </template>

                <template v-slot:cell(min_sale_amount_fmted)="data">
                  <span v-if="data.item.min_sale_amount === 1">1 unidade</span>
                  <span v-else>{{ data.item.min_sale_amount }} unidades</span>
                </template>

                <template v-slot:cell(value_fmted)="data">
                  <span v-if="data.item.value > 0">{{ data.item.value | currency }}</span>
                  <span v-else class="text-info">Grátis</span>
                </template>

                <template v-slot:head(reserved_stock_fmted)>
                    <div>
                      Estoque reservado
                      <span v-b-tooltip.hover title="Pedidos da Loja Virtual retiram os itens do estoque, como reserva, até que o pagamento seja efetuado. Caso o pagamento não seja efetuado, o estoque é reposto automaticamente.">
                        <icon name="info-circle" scale="0.8"></icon>
                      </span>
                    </div>
                </template>

                <template v-slot:cell(reserved_stock_fmted)="data">
                  <span>{{ data.item.reserved_stock }}</span>
                </template>

                <template v-slot:cell(max_validations_fmted)="data">
                  <span v-if="data.item.max_validations === 1">{{ data.item.max_validations }} vez</span>
                  <span v-else>{{ data.item.max_validations }} vezes</span>
                </template>

                <template v-slot:cell(category_fmted)="data">
                  <span v-if="data.item.category">{{ data.item.category.emoji }} {{ data.item.category.category }}</span>
                  <span v-else class="text-muted">—</span>
                </template>

                <template v-slot:cell(actions)="data">
                  <b-button class="mr-1" size="sm" :variant="data.item.print_amount > 0 && $gui.isEvento ? 'warning' : 'secondary'" @click="openBatchEdit(data.item.id)">
                    <icon name="pen-fancy" scale="1" class="mx-0"></icon>
                  </b-button>

                  <b-button
                    @click="getHistories(data.item.id)" class="mr-2"
                    v-b-modal.history-batches size="sm" v-b-tooltip.hover title="Histórico de edições">
                    <icon name="history" class="mx-0"></icon>
                  </b-button>

                  <toggle-button :value="data.item.is_available === 1"
                    :sync="true" :width="45" :height="25"
                    :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
                    @change="switchBatch(data.item.id)" class="mt-2 ml-2" />

                </template>
              </b-table>
            </b-col>
          </b-row>

        </b-col>

        <!-- Criar lote -->
        <b-col v-show="!formCollapsed" cols="12" lg="4">
          <div id="cadastrar-novo" class="p-4" style="background-color: #f8fbff;">
            <h2 class="d-flex justify-content-between align-items-center">
              Cadastrar {{ $gui.batchLC }}
              <b-button variant="primary" size="sm" @click="toggleForm(true)" v-b-tooltip.hover title="Encolher formulário">
                <icon name="chevron-up" scale="0.9" class="mx-0"></icon>
              </b-button>
            </h2>
            <b-alert :variant="feedback.type" dismissible :show="feedback.show" fade
              @dismissed="feedback.show=false">
                {{ feedback.data }}
            </b-alert>

            <b-form @submit.prevent="createBatch">
              <b-form-group
                :description="this.$gui.batchesExample">
                  <p class="mb-2 font-weight-bold">Nome do {{ $gui.batchLC }}</p>
                  <b-form-input
                    type="text"
                    v-model.trim="form.name"
                    ref="batchName"
                    required>
                  </b-form-input>
              </b-form-group>

              <b-form-group
                description="Exemplo: R$ 30,00">
                <p class="mb-2 font-weight-bold">Valor do {{ $gui.batchLC }}</p>
                <b-input-group prepend="R$">
                  <money required class="form-control" v-model="form.value" v-bind="money"></money>
                </b-input-group>
              </b-form-group>

              <b-form-group
                v-if="this.$gui.isEvento"
                description="O intervalo entre validações do mesmo ingresso é de 6 horas.">

                <p class="mb-2 font-weight-bold">Limite máximo de validações</p>
                <b-form-select v-model.number="form.max_validations" :options="maxValidationsOptions"></b-form-select>
              </b-form-group>

              <b-form-group>
                <p class="mb-2 font-weight-bold">Estoque do {{ $gui.batchLC }}</p>

                <b-form-checkbox
                  v-model="unlimitedStock" switch>
                  {{ unlimitedStock ? 'Estoque ilimitado ativado' : 'Estoque ilimitado desativado' }}
                </b-form-checkbox>

                <b-form-group class="mt-3 mb-0" v-if="unlimitedStock === false">
                  <p class="mb-2 font-weight-bold">Defina o estoque inicial do {{ $gui.batchLC }}</p>
                  <b-input-group append="unidades">
                    <b-form-input
                      type="number"
                      v-model.number="form.stock">
                    </b-form-input>
                  </b-input-group>
                </b-form-group>

              </b-form-group>

              <b-form-group
                :description="'A Loja Virtual só aceita compras deste ' + $gui.batchLC + ' em múltiplos deste número. Use 1 para permitir qualquer quantidade.'">
                <p class="mb-2 font-weight-bold">Mínimo de unidades por venda</p>
                <b-form-input type="number" min="1" max="30" step="1" v-model.number="form.min_sale_amount"></b-form-input>
              </b-form-group>

              <!-- Categoria -->
              <b-form-group v-if="event && event.categories_enabled === 1 && categories.length > 0">
                <p class="mb-2 font-weight-bold">Categoria</p>
                <b-form-select v-model="form.category_id" :options="categoryOptions"></b-form-select>
              </b-form-group>

              <!-- Associar ao revendedor -->
              <!-- ---------------------- -->
              <b-form-group v-if="event.dealers && event.dealers.length > 0">
                <p class="mb-2 font-weight-bold">Ativar {{ $gui.batchLC }} para o {{ $gui.dealerLC }}?</p>

                <b-form-checkbox
                  v-model="associateBatch" switch>
                  {{ associateBatch ?  'Sim, ativar' : 'Não, cadastrar desativado' }}
                </b-form-checkbox>

                <b-form-group class="mt-3 mb-0" v-if="associateBatch === true">
                  <p class="mb-2 font-weight-bold">Escolha os {{ $gui.dealersLC }} para ativar o {{ $gui.batchLC }}:</p>

                  <b-form-checkbox class="mb-3 text-primary" v-if="dealersExceptOnlineSeller.length > 1" v-model="allDealersSelected" @change="selectAllDealers">Marcar todos {{ $gui.dealersLC }}</b-form-checkbox>

                  <b-form-checkbox-group stacked v-model="form.dealers">
                    <b-form-checkbox class="mb-2"
                      v-for="dealer in dealersExceptOnlineSeller"
                      :key="dealer.id"
                      :value="dealer.id"
                      @change="selectOneDealer">
                        {{ dealer.name }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>

              </b-form-group>

              <b-button type="submit" variant="primary" class="mt-2">Cadastrar {{ associateBatch && form.dealers.length > 0 ? 'e ativar ' : '' }} {{ this.$gui.batchLC }}</b-button>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <batch-series-modal
      :visible="showSeriesModal"
      :event="event"
      :organizer="organizer"
      :categories="categories"
      @close="showSeriesModal = false"
      @created="onSeriesCreated"
    ></batch-series-modal>

    <batch-price-modal
      :visible="showPriceModal"
      :items="effectiveSelection"
      :organizer="organizer"
      @close="showPriceModal = false"
      @updated="onPricesUpdated"
      @reload="getEvent"
    ></batch-price-modal>

    <modal v-if="showModal" ref="modal">
      <router-view name="content"/>
    </modal>

    <b-modal id="filter-batch-name"
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      :title="'Filtrar por nome do ' + $gui.batchLC"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe o nome e feche para filtrar</p>
      <b-form-input
        v-model="filter.name"
        type="search"
        :autofocus="true"
        :placeholder="'Nome do ' + $gui.batchLC"
        @input="updateFilter('name', $event)"
      ></b-form-input>
    </b-modal>

    <b-modal id="filter-batch-stock"
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Estoque"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Selecione e feche para filtrar</p>
      <b-form-group>
        <b-form-radio :checked="filter.stock" value="" @change="updateFilter('stock', '')">Todos {{ $gui.batchesLC }}</b-form-radio>
        <b-form-radio :checked="filter.stock" value="-1" @change="updateFilter('stock', '-1')">Estoque ilimitado</b-form-radio>
        <b-form-radio :checked="filter.stock" value="0" @change="updateFilter('stock', '0')">Sem estoque</b-form-radio>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-batch-situation"
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Situação"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Selecione e feche para filtrar</p>
      <b-form-group>
        <b-form-radio :checked="filter.situation" value="" @change="updateFilter('situation', '')">Todas</b-form-radio>
        <b-form-radio v-for="(info, key) in situationLabels" :key="key" :checked="filter.situation" :value="key" @change="updateFilter('situation', key)">{{ info.label }}</b-form-radio>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-batch-price"
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Preço"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Selecione e feche para filtrar</p>
      <b-form-group>
        <b-form-radio :checked="filter.price" value="" @change="updateFilter('price', '')">Todos {{ $gui.batchesLC }}</b-form-radio>
        <b-form-radio :checked="filter.price" value="0" @change="updateFilter('price', '0')">Grátis</b-form-radio>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-batch-category"
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Categoria"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque uma ou mais e feche para filtrar</p>
      <b-form-group>
        <b-form-checkbox
          :checked="filter.noCategory"
          @change="updateFilter('noCategory', $event)"
        >Sem categoria</b-form-checkbox>
        <hr class="my-2">
        <b-form-checkbox-group
          :checked="filter.category_ids"
          :options="categories.map(c => ({ value: String(c.id), text: c.emoji ? c.emoji + ' ' + c.category : c.category }))"
          stacked
          @input="updateFilter('category_ids', $event)"
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="history-batches"
      size="xl"
      scrollable
      ok-only
      ok-title="Fechar"
      ok-variant="primary"
      title="Histórico de edições"
    >

      <b-table striped hover show-empty
        class="my-4"
        primary-key="id"
        empty-text="Nenhuma edição encontrada"
        responsive="md"
        :fields="fieldsHistoryBatch"
        :items="historyBatch.histories"
        >

          <template v-slot:cell(diffs)="data">
            <div>
              <ul class="pl-3 m-0" style="list-style-type: circle;">
                <li v-if="data.item.old.name !== data.item.new.name">
                  <span class="font-weight-bold">Nome:</span> {{ data.item.old.name }} <icon scale="0.6" name="arrow-right" style="margin: 0 6px 2px 6px; color: blue;"></icon> {{ data.item.new.name }}
                </li>
                <li v-if="data.item.old.value !== data.item.new.value">
                  <span class="font-weight-bold">Preço:</span> {{ data.item.old.value | currency }} <icon scale="0.6" name="arrow-right" style="margin: 0 6px 2px 6px; color: blue;"></icon> {{ data.item.new.value | currency }}
                </li>
                <li v-if="data.item.old.stock !== data.item.new.stock">
                  <span class="font-weight-bold">Estoque:</span>

                  {{ data.item.old.stock == null ? 'Ilimitado' : data.item.old.stock }}
                    <icon scale="0.6" name="arrow-right" style="margin: 0 6px 2px 6px; color: blue;"></icon>
                  {{ data.item.new.stock == null ? 'Ilimitado' : data.item.new.stock  }}
                </li>
              </ul>
            </div>
          </template>

      </b-table>

    </b-modal>
  </div>
</template>

<script>
import {Money} from 'v-money'
import ToggleButton from 'vue-js-toggle-button/src/Button'
import Modal from '@/components/Modal'
import BatchSeriesModal from '@/components/BatchSeriesModal'
import BatchPriceModal from '@/components/BatchPriceModal'
import FilterStore from '@/filterStore'

export default {
  name: 'OrganizerBatches',
  components: {
    ToggleButton,
    Money,
    Modal,
    BatchSeriesModal,
    BatchPriceModal
  },
  data () {
    return {
      showModal: this.$route.meta.showModal,
      showSeriesModal: false,
      showPriceModal: false,
      selectedIds: [],
      shownIds: [],
      organizer: '',
      event: {},
      form: {
        name: '',
        value: '',
        max_validations: 1,
        min_sale_amount: 1,
        stock: null,
        dealers: [],
        category_id: null
      },
      categories: [],
      unlimitedStock: true,
      associateBatch: false,
      feedback: {
        data: '',
        type: '',
        show: false
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2
      },
      maxValidationsOptions: [
        { value: 1, text: '1 - Uma vez' },
        { value: 2, text: '2 - Duas vezes' },
        { value: 3, text: '3 - Três vezes' },
        { value: 4, text: '4 - Quatro vezes' },
        { value: 5, text: '5 - Cinco vezes' },
      ],
      fieldsEvento: [
        {key: 'select', label: '', class: ['align-middle', 'text-center']},
        {key: 'name', label: this.$gui.batch, class: ['align-middle'], thStyle: { minWidth: '250px' }, tdStyle: { minWidth: '250px' } },
        {key: 'value_fmted', label: 'Preço', formatter: this.$options.filters.currency, class: ['text-nowrap', 'align-middle', 'text-center']},
        {key: 'stock_fmted', label: 'Estoque', class: ['align-middle', 'text-center']},
        {key: 'situation_fmted', label: 'Situação', class: ['align-middle', 'text-center']},
        {key: 'min_sale_amount_fmted', label: 'Mínimo por venda', class: ['align-middle', 'text-center']},
        {key: 'reserved_stock_fmted', label: 'Estoque reservado', class: ['align-middle', 'text-center']},
        {key: 'max_validations_fmted', label: 'Limite máximo de validações', class: ['align-middle', 'text-center']},
        {key: 'category_fmted', label: 'Categoria', class: ['align-middle', 'text-center']},
        {key: 'actions', label: 'Ações', class: ['text-nowrap', 'text-center', 'align-middle']},
      ],
      fieldsFicha: [
        {key: 'select', label: '', class: ['align-middle', 'text-center']},
        {key: 'name', label: this.$gui.batch, class: ['align-middle'], thStyle: { minWidth: '250px' }, tdStyle: { minWidth: '250px' } },
        {key: 'value_fmted', label: 'Preço', formatter: this.$options.filters.currency, class: ['text-nowrap', 'align-middle', 'text-center']},
        {key: 'stock_fmted', label: 'Estoque', class: ['align-middle', 'text-center']},
        {key: 'situation_fmted', label: 'Situação', class: ['align-middle', 'text-center']},
        {key: 'min_sale_amount_fmted', label: 'Mínimo por venda', class: ['align-middle', 'text-center']},
        {key: 'category_fmted', label: 'Categoria', class: ['align-middle', 'text-center']},
        {key: 'actions', label: 'Ações', class: ['text-nowrap', 'text-center', 'align-middle']},
      ],
      filter: {
        name: '',
        stock: '',
        price: '',
        situation: '',
        category_ids: [],
        noCategory: false
      },
      situationLabels: {
        available: { label: 'Disponível', variant: 'success' },
        reserved: { label: 'Reservado', variant: 'warning' },
        sold: { label: 'Vendido', variant: 'secondary' },
        out_of_stock: { label: 'Sem estoque', variant: 'danger' }
      },
      appliedFilters: [],
      filterStore: null,
      historyBatch: '',
      fieldsHistoryBatch: [
        { key: 'diffs', label: 'Histórico', class: ['align-middle', 'text-nowrap'] },
        { key: 'created_at', label: 'Data', formatter: this.$options.filters.date, class: ['align-middle', 'text-nowrap', 'text-center'] },
        { key: 'user', label: 'Usuário', tdClass: ['data-extra'], class: ['text-center', 'align-middle', 'text-nowrap'] },
        { key: 'user_agent', label: 'Dispositivo', formatter: this.$options.filters.userAgent, tdClass: ['data-extra'], class: ['text-center', 'align-middle', 'text-nowrap'] },
        { key: 'location', label: 'Local', tdClass: ['data-extra'], class: ['text-center', 'align-middle', 'text-nowrap'] },
      ],
      allDealersSelected: false,
      formCollapsed: false
    }
  },
  watch: {
    '$route.meta' ({showModal}) {
      this.showModal = showModal
    },
    '$route' (to, from) {
      if (from.name === 'OrganizerBatchEdit' && to.name === 'OrganizerBatches') {
        this.getEvent()
      }
    }
  },
  mounted () {
    this.organizer = this.$route.params.organizer
    this.filterStore = new FilterStore(this.organizer, this.$route.path)
    this.filter = this.filterStore.merge(this.filter)
    const saved = this.filterStore.retrieve()
    if (saved && saved.formCollapsed !== undefined) this.formCollapsed = saved.formCollapsed
    this.getEvent().then(async () => {
      await this.loadCategories()
      this.buildAppliedFilters()
    })
  },

  methods: {
    selectAllDealers (checked) {
      this.form.dealers = []
      if (!checked) return
      for (let x = 0; x < this.dealersExceptOnlineSeller.length; x++) {
        this.form.dealers.push(this.dealersExceptOnlineSeller[x].id)
      }
    },
    selectOneDealer () {
      this.allDealersSelected = false
    },
    toggleForm (collapsed) {
      this.formCollapsed = collapsed
      this.filterStore.save('formCollapsed', collapsed)
    },
    updateFilter (key, value) {
      this.filter[key] = value
      this.filterStore.save(key, value)
      this.buildAppliedFilters()
    },
    buildAppliedFilters () {
      this.appliedFilters = []
      if (this.filter.name !== '') {
        this.appliedFilters.push({ filter: 'Nome', values: this.filter.name })
      }
      if (this.filter.stock !== '') {
        const labels = { '-1': 'Estoque ilimitado', '0': 'Sem estoque' }
        this.appliedFilters.push({ filter: 'Estoque', values: labels[this.filter.stock] || this.filter.stock })
      }
      if (this.filter.price !== '') {
        this.appliedFilters.push({ filter: 'Preço', values: 'Grátis' })
      }
      if (this.filter.situation !== '' && this.situationLabels[this.filter.situation]) {
        this.appliedFilters.push({ filter: 'Situação', values: this.situationLabels[this.filter.situation].label })
      }
      if (this.filter.noCategory || (this.filter.category_ids && this.filter.category_ids.length > 0)) {
        const names = []
        if (this.filter.noCategory) names.push('Sem categoria')
        if (this.filter.category_ids) {
          this.filter.category_ids.forEach(id => {
            const cat = this.categories.find(c => String(c.id) === id)
            if (cat) names.push(cat.emoji ? cat.emoji + ' ' + cat.category : cat.category)
          })
        }
        this.appliedFilters.push({ filter: 'Categoria', values: names.join(', ') })
      }
    },
    resetFilterBatches () {
      this.filter.name = ''
      this.filter.stock = ''
      this.filter.price = ''
      this.filter.situation = ''
      this.filter.category_ids = []
      this.filter.noCategory = false
      this.appliedFilters = []
      this.filterStore.clear()
    },
    filterBatches (row, filter) {
      const noCategoryActive = filter.noCategory
      const categoryIdsActive = filter.category_ids && filter.category_ids.length > 0
      if (filter.name === '' && filter.stock === '' && filter.price === '' && !filter.situation && !noCategoryActive && !categoryIdsActive) {
        return true
      }
      let nameFilter = filter.name !== '' && row.name.toLowerCase().match(filter.name.toLowerCase())
      let unlimitedStockFilter = filter.stock !== '' && filter.stock === '-1' && row.stock === null
      let noStockFilter = filter.stock !== '' && filter.stock !== '-1' && Number(filter.stock) === row.stock
      let freePrice = filter.price !== '' && Number(filter.price) === row.value
      let categoryFilter = categoryIdsActive && row.category && filter.category_ids.includes(String(row.category.id))
      let noCategoryFilter = noCategoryActive && !row.category

      return (nameFilter || filter.name === '')
        && (unlimitedStockFilter || noStockFilter || filter.stock === '')
        && (freePrice || filter.price === '')
        && (!filter.situation || row.situation === filter.situation)
        && (categoryFilter || noCategoryFilter || (!noCategoryActive && !categoryIdsActive))
    },
    getEvent () {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/events'

      return this.$http.get(url).then(res => {
        this.event = res.body
        this.shownIds = (res.body.batches || []).map(b => b.id)
      }, err => {
        console.log(err)
      })
    },
    async loadCategories () {
      try {
        const url = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/categories`
        const resp = await this.$http.get(url)
        this.categories = resp.body.categories || []
      } catch (err) {
        console.error(err)
      }
    },
    async getHistories (batchId) {
      try {
        let url = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/batches/${batchId}/histories`
        let resp = await this.$http.get(url)
        this.historyBatch = resp.body
      } catch (err) {
        console.error(err)
      }
    },
    removerAcentos (str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    },
    ehPacote(nomeLote) {
      const palavrasPacote = ["pacote", "passaporte", "combo", "kit", "multi", "multiplo", "multiuso", "full", "weekend", "festival", "acesso", "total", "completo", "todos", "dias", "ingresso", "entrada", "ilimitado", "extendido", "estendido", "livre", "geral", "passe", "aberto", "integral", "continuo", "semana", "diario", "evento", "sessoes", "permanente", "periodo", "sem limite", "circular", "gold", "vip", "superior", "max", "plus", "master", "mega", "longo", "varios", "horas", "sem restricao", "all", "day", "week", "free", "unico", "duracao"]
      const nomeSanitizado = this.removerAcentos(nomeLote.toLowerCase())
      return palavrasPacote.some(palavra => nomeSanitizado.includes(palavra))
    },
    async createBatch () {
      if (!(Number.isInteger(this.form.min_sale_amount) && this.form.min_sale_amount >= 1 && this.form.min_sale_amount <= 30)) {
        this.feedback.data = 'O mínimo de unidades por venda deve ser um número inteiro de 1 a 30.'
        this.feedback.type = 'danger'
        this.feedback.show = true
        return false
      }

      const er = /((\d{2},){1}\d{2}\/\d{2})|(\d{2}\s(e|E)\s\d{2})|(\d{2}\/\d{2}\s(ao|e|à|á|a|at[eéè]|-)\s\d{2}\/\d{2})/
      let detectedPack = this.form.name.match(er) !== null

      if (this.$gui.isEvento && this.form.max_validations <= 1 && (detectedPack || this.ehPacote(this.form.name))) {
        const action = await this.$bvModal.msgBoxConfirm("Parece que você esqueceu de escolher a quantidade de vezes que este pacote poderá ser validado. Quer mesmo prosseguir?", {
          title: '⚠ Limite máximo de validações',
          okVariant: 'primary',
          cancelVariant: 'danger',
          okTitle: 'Cadastrar assim mesmo',
          cancelTitle: 'Voltar e corrigir',
          centered: true,
          hideHeaderClose: false
        })

        if (action === false || !action) {
          return false
        }
      }

      let batch = {
        name: this.form.name,
        value: Math.round(this.form.value * 100),
        max_validations: this.form.max_validations,
        min_sale_amount: this.form.min_sale_amount,
        stock: this.unlimitedStock ? null : this.form.stock,
        category_id: this.form.category_id
      }

      if (this.form.dealers.length > 0) {
        batch['dealers'] = this.form.dealers
      }

      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/batches'

      try {
        await this.$http.post(url, batch)
        this.feedback.data = `${this.$gui.batch} criado com sucesso!`
        this.feedback.type = 'success'
        this.feedback.show = true
        this.form.name = ''
        this.form.value = 0
        this.form.max_validations = 1
        this.form.min_sale_amount = 1
        this.form.stock = null
        this.form.dealers = []
        this.form.category_id = null
        this.unlimitedStock = true
        this.$refs.batchName.$el.focus()
        await this.getEvent()
      } catch (err) {
        console.error(err)
        this.feedback.data = err.body.message
        this.feedback.type = 'danger'
        this.feedback.show = true
      }
    },
    switchBatch (batchId) {
      let i = this.$_.findIndex(this.event.batches, b => b.id === batchId)
      let state = this.event.batches[i].is_available
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/batches/' + batchId

      if (state === 0) {
        url += '/enable'
      } else if (state === 1) {
        url += '/disable'
      }

      this.$http.put(url, {}).then(res => {
        if (state === 0) {
          this.event.batches[i].is_available = 1
        } else if (state === 1) {
          this.event.batches[i].is_available = 0
        }
      }, err => {
        alert(err.body.message)
        console.log(err)
      })
    },
    onFiltered (items) {
      this.shownIds = items.map(b => b.id)
    },
    lockMessage (lock) {
      if (lock === 'tickets') return 'Preço bloqueado: já existem ingressos gerados para este ' + this.$gui.batchLC + '.'
      if (lock === 'orders') return 'Preço bloqueado: existe pedido da Loja Virtual pendente de pagamento ou pago.'
      return ''
    },
    toggleAllShown (checked) {
      this.selectedIds = checked ? this.selectableShown.map(b => b.id) : []
    },
    onPricesUpdated (body) {
      let text = `Preço alterado em ${body.updated} ${this.$gui.batchesLC}.`
      if (body.unchanged > 0) text = text.slice(0, -1) + `, ${body.unchanged} já tinham este preço.`
      this.feedback.data = text
      this.feedback.type = 'success'
      this.feedback.show = true
      this.selectedIds = []
      this.getEvent()
    },
    toggleSituation (key) {
      this.updateFilter('situation', this.filter.situation === key ? '' : key)
    },
    onSeriesCreated (body) {
      this.feedback.data = `${body.created} ${this.$gui.batchesLC} criados.`
      this.feedback.type = 'success'
      this.feedback.show = true
      this.getEvent()
    },
    openBatchEdit (batchId) {
      this.$router.push({name: 'OrganizerBatchEdit', params: { id: batchId }})
    }
  },
  computed: {
    selectableShown () {
      const shown = new Set(this.shownIds)
      return (this.event.batches || []).filter(b => shown.has(b.id) && !b.price_lock)
    },
    effectiveSelection () {
      const selected = new Set(this.selectedIds)
      return this.selectableShown.filter(b => selected.has(b.id))
    },
    allShownSelected () {
      return this.selectableShown.length > 0 && this.effectiveSelection.length === this.selectableShown.length
    },
    situationSummary () {
      const counts = {}
      ;(this.event.batches || []).forEach(b => { counts[b.situation] = (counts[b.situation] || 0) + 1 })
      const plural = {
        available: ['disponível', 'disponíveis'],
        reserved: ['reservado', 'reservados'],
        sold: ['vendido', 'vendidos'],
        out_of_stock: ['sem estoque', 'sem estoque']
      }
      return Object.keys(plural).map(key => {
        const count = counts[key] || 0
        return { key, count, text: count + ' ' + plural[key][count === 1 ? 0 : 1] }
      })
    },
    dealersExceptOnlineSeller () {
      return this.$_.filter(this.event.dealers, d => d.type !== 'online')
    },
    categoryOptions () {
      const opts = [{ value: null, text: 'Sem categoria' }]
      for (const c of this.categories) {
        opts.push({ value: c.id, text: `${c.emoji} ${c.category}` })
      }
      return opts
    }
  }
}
</script>

<style lang="scss">
.window {
  width: 474px !important;
}
</style>
